module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__save"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "save_day_one_fatal"
    }
  }, [_c('button', {
    staticClass: "a-button"
  }, [_vm._v("\n            " + _vm._s(!_vm.exists ? 'Save as new claim' : 'Update Claim') + "\n        ")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "save_day_one_fatal",
      "no-default-button": "true",
      "wide": ""
    }
  }, [(!_vm.showList) ? _c('div', {
    staticClass: "c-save-as-new-claim"
  }, [_c('h1', [_vm._v("Save your assessment")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exists),
      expression: "!exists"
    }]
  }, [_vm._v("\n                Click the button below to attach this assessment to existing claim\n                or complete the form to save as a new claim\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Claim details")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "for": "claimant_name",
      "label": "Claimant Name"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantName),
      expression: "claimantName"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_name')
    }
  }, [_vm._v("\n                            The claimant name is required.\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Claimant Solicitors',
      "error-message": 'The claimant solicitor is required.',
      "value": _vm.claimantSolicitors,
      "type": 'claimant_solicitors'
    },
    on: {
      "update": _vm.updateClaimantSolicitors
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "claimant_reference",
      "label": "Claimant Solicitors Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.claimantReference),
      expression: "claimantReference"
    }],
    attrs: {
      "type": "text",
      "name": "claimant_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.claimantReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimantReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_reference')
    }
  }, [_vm._v("\n                            The claimant solicitors reference name is required.\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "your_reference",
      "label": "Your Reference"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.yourReference),
      expression: "yourReference"
    }],
    attrs: {
      "type": "text",
      "name": "your_reference",
      "required": ""
    },
    domProps: {
      "value": (_vm.yourReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yourReference = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('your_reference')
    }
  }, [_vm._v("\n                            Your reference is required\n                        ")])], 1), _vm._v(" "), _c('typeahead', {
    attrs: {
      "required": true,
      "label": 'Defendant Name',
      "error-message": 'The defendant name is required.',
      "value": _vm.defendantName,
      "type": 'defendant'
    },
    on: {
      "update": _vm.updateDefendant
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }]
  }, [_vm._v("\n                        All fields are required.\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small a-button--loader-button",
    class: [_vm.isSaving ? 'a-loader--white' : ''],
    attrs: {
      "disabled": !_vm.updateValid()
    },
    on: {
      "click": _vm.doSave
    }
  }, [_c('span', {
    class: [_vm.isSaving ? 'a-button--span-hidden' : '']
  }, [_vm._v(_vm._s(_vm.exists ? "Update" : "Save"))])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.routeToClaim
    }
  }, [_vm._v("Open as Claim\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("Download Day\n                        One Summary\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('button', {
    staticClass: "a-button a-button--small",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                        Attach to existing claim\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.exists) ? _c('p', [_c('span', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("Save your claim before you can download the summary.")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showList) ? _c('div', {
    staticClass: "c-attached-to-existing"
  }, [_c('a', {
    staticClass: "u-float-r u-cursor-pointer",
    on: {
      "click": _vm.toggleClaimList
    }
  }, [_vm._v("\n                Return to save new claim\n            ")]), _vm._v(" "), _c('claim-table', {
    on: {
      "select": _vm.attachToClaim
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f485a00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/lost/DayOneSave.vue
// module id = 1773
// module chunks = 0